export {
  NavigationWrapper,
  type NavigationWrapperProps,
} from './NavigationWrapper';
